<template>
  <div class="compare-localtion" :class="{'inline': showInline}">
    <div class="compare-title">{{t('comparar_con')}}</div>
    <!--<div class="compare-shortcuts">
      <div class="shortcut-btn" @click="setCompareNode">{{t('total_es')}}</div>
      <div class="shortcut-btn">{{t('total_ccaa')}}</div>
      <div class="shortcut-btn">{{t('total_prov')}}</div>
    </div>-->
    <location-search :buttonLabel="t('comparar')" @change="compareLocation" :showInline="showInline"></location-search>
  </div>
</template>

<script>
import LocationSearch from '@/components/LocationSearch'

export default {
  name: "CompareLocation",
  props: ['text', 'showInline'],
  components: {LocationSearch},
  data () {
    return {
      compare_node_id: null,
      compare_node_glk: null
    }
  },
  routerLinkedData: ['compare_node_id', 'compare_node_glk'],
  computed: {
  },
  methods: {
    setCompareNode() {
      this.compareLocation({
        id: '-1311341',
        glk: 'COUNTRY'
      })
    },
    compareLocation(location) {
      this.compare_node_id = location.id
      this.compare_node_glk = location.glk
    }
  }
}
</script>

<style lang="stylus" scoped>
.compare-localtion
  text-align center
  display flex
  flex-direction column
  flex-wrap: wrap
  &.inline
    flex-direction row
    text-align left
    .compare-title
      flex 1 1 100%
      border-bottom none
    .compare-shortcuts
      border-bottom none
      width 35%
      margin-right vw(10px)
    .location-search
      flex 1 1 60%
  .compare-title
    margin 10px 0px
    m-font-size(14,16)
  .compare-shortcuts
    display flex
    margin 10px 0px
    padding-bottom vw(22px)
    width 100%
    .shortcut-btn
      flex 1 1 33%
      font-family: "Lato"
      m-font-size(14,17)
      display flex
      align-items center
      justify-content center
      cursor pointer
      padding 5px
      background #fff
      border 1px solid black
      height 42px

</style>